/* Oakman Pre-TENCEL scroll film.
   Ported verbatim from prototype-pretencel-v1/index.html (rev32).
   Two IIFEs, no shared globals: the footer film, then the scroll engine.
   Asset URLs arrive via window.OAK, set by sections/oakman-pretencel.liquid. */

/* ---- footer film (was inline at line 1214) ---- */
(function(){
  var s=document.getElementById('filmfoot'), v=document.getElementById('footfilm');
  if(!s||!v) return;

  /* phones: the wide 16:3 bake would crop to a sliver, so the footer runs the
     hero cut itself at 16/9 (already cached from the top of the page) */
  if(document.documentElement.clientWidth<900) v.src=window.OAK.heroDesktop;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    v.preload='metadata'; v.currentTime=0.7; return;
  }

  function start(){ v.preload='auto'; v.play().catch(function(){}); }
  function stop(){ if(!v.paused) v.pause(); }

  if(!('IntersectionObserver' in window)){ start(); return; }
  new IntersectionObserver(function(es){
    es.forEach(function(e){ e.isIntersecting ? start() : stop(); });
  },{rootMargin:'220px 0px'}).observe(s);
})();

/* ---- scroll engine (was inline at line 1345) ---- */
(function(){
'use strict';
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------- artboard scaler: 1600 design px -> viewport ---------- */
/* ---------- the scene deck ----------
   Each scene: wrapper height = 1 viewport (pin) + internal travel (stages taller
   than the window scroll 1:1 inside the frame) + read dwell + the next scene's fade.
   Every scene after the first is pulled up a full viewport + fade so it is already
   pinned and invisible beneath the fold, then simply fades in. */
/* Desktop keeps the long dissolve and read dwell (mouse wheels glide). Phones get a
   shorter deck: a thumb flick is ~1 screen, and at .85 + .5 screens per block Mandy
   needed 3-4 swipes to reach the next scene. Tunable from the URL for taste tests:
   ?fade=.4&read=.2 (fractions of a screen). layout() picks the pair for the width. */
var FADE_D=.85, READ_D=.5, FADE_M=.4, READ_M=.25;
(function(){ var q=location.search, f=/[?&]fade=([\d.]+)/.exec(q), r=/[?&]read=([\d.]+)/.exec(q);
  if(f) FADE_M=FADE_D=parseFloat(f[1]); if(r) READ_M=READ_D=parseFloat(r[1]); })();
var FADEF=FADE_D, READF=READ_D, LIVES={b3pin:1.15};
/* content scenes sit back from the glass; photo-led scenes stay full-bleed */
var ZOOM=.85, BLEED={b1:1,b2:1,b7:1,b4:1};
/* MOBILE (rev20): below MOBILE_BP each scene swaps to its portrait board.
   The deck maths are identical; only the artboard (W x h) changes. */
var MOBILE_BP=900, MW=390, mobile=false;
var scenes = Array.prototype.slice.call(document.querySelectorAll('.scene')).map(function(el){
  return {el:el, stick:el.querySelector('.stick'),
          dstage:el.querySelector('.stage.d'), mstage:el.querySelector('.stage.m'),
          stage:el.querySelector('.stage.d'),
          dh:parseFloat(el.getAttribute('data-h')), mh:parseFloat(el.getAttribute('data-mh'))||780,
          h:parseFloat(el.getAttribute('data-h')), live:LIVES[el.id]||0,
          bleed:!!BLEED[el.id], T:0, s:1};
});
var heroSeqEl=document.getElementById('heroSeq');
/* VIEWPORT HEIGHT ON PHONES (Sep 18-21).
   Browser bars come and go while you scroll, and window.innerHeight moves with them; laying
   the deck out from that rescaled every board on every toggle (the "zoom"). Sizing to the
   CSS small viewport (100svh) held still but left up to a third of the screen dead once the
   bars hid, because iPhone Chrome reports svh ~640 and even lvh ~783 on a screen that shows
   ~875 with its bars away. Re-centring boards against the live viewport made them swim.
   So on phones the deck is built ONCE for the tallest height the phone can actually show
   (MAXH): frames, board scale and board position all come from it and never change
   afterwards. When the bars are up they cover the bottom of the frame, exactly as they
   cover the bottom of any page. MAXH = the largest of the lvh probe, innerHeight, and on
   iOS the screen height less the status bar; it only ever grows (a resize that reveals more
   height re-lays out once, and that is the only height-driven layout on a phone).
   Desktop keeps the ordinary live viewport. */
var vhProbe=document.createElement('div');
vhProbe.style.cssText='position:fixed;top:0;left:0;width:0;height:100svh;visibility:hidden;pointer-events:none;';
(document.body||document.documentElement).appendChild(vhProbe);
var lvhProbe=document.createElement('div');
lvhProbe.style.cssText='position:fixed;top:0;left:0;width:0;height:100lvh;visibility:hidden;pointer-events:none;';
(document.body||document.documentElement).appendChild(lvhProbe);
var IOS=/iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform==='MacIntel' && navigator.maxTouchPoints>1);
var VH=0, MAXH=0, lastVW=-1, hstageEl=document.querySelector('.hstage');
function readVH(){ var h=vhProbe.offsetHeight; return h>0 ? h : window.innerHeight; }
function readLVH(){ var h=lvhProbe.offsetHeight; return h>0 ? h : readVH(); }
function readMAXH(){
  var m=Math.max(readLVH(), window.innerHeight||0);
  if(IOS && screen && screen.height){ m=Math.max(m, screen.height-59); }   /* 59 = Dynamic Island / notch status bar */
  return Math.max(m, MAXH);
}
function onResize(){
  var vw=document.documentElement.clientWidth;
  if(vw<MOBILE_BP && vw===lastVW){
    /* bars toggling: ignore, unless the phone just revealed more height than we ever knew */
    if(window.innerHeight > MAXH+2){ layout(); }
    return;
  }
  if(vw!==lastVW) MAXH=0;   /* rotation: measure the new orientation from scratch */
  layout();
}
function layout(){
  var vw = document.documentElement.clientWidth;
  mobile = vw < MOBILE_BP;
  if(mobile){ MAXH = readMAXH(); }
  var vh = VH = mobile ? MAXH : readVH();
  lastVW = vw;
  FADEF = mobile ? FADE_M : FADE_D; READF = mobile ? READ_M : READ_D;
  document.body.classList.toggle('m', mobile);
  document.body.classList.toggle('d', !mobile);
  var W = mobile ? MW : 1600;
  /* phones: frames are MAXH tall (CSS says 100svh, which is too short on iPhone Chrome) */
  var extra = 0;
  if(hstageEl) hstageEl.style.height = (mobile && !reduced) ? vh+'px' : '';
  heroSeqEl.style.height = reduced ? '100svh' : ((1 + .55 + FADEF) * vh)+'px';
  var RAIL = (vw >= 1100) ? 16 : 0;   /* the resting sliver owns the right edge */
  var vwe = vw - RAIL;
  var s = vwe/W;
  scenes.forEach(function(sc,i){
    sc.stage = (mobile && sc.mstage) ? sc.mstage : sc.dstage;
    sc.h = (mobile && sc.mstage) ? sc.mh : sc.dh;
    /* content scenes sit back AND always fit whole: no scrolling to see a bottom edge.
       on phones nothing sits back (ZOOM 1): the board already has its own margins */
    var zoom = mobile ? 1 : ZOOM;
    var ss = sc.bleed ? s : Math.min(s*zoom, (vh*.96)/sc.h);
    /* a bleed board on a phone still has to fit whole: short phones scale it down */
    if(mobile && sc.bleed) ss = Math.min(s, (vh*.98)/sc.h);
    var hs = sc.h*ss;
    sc.T = 0; sc.s = ss;
    sc.stage.style.left = ((vwe - W*ss)/2)+'px';
    if(reduced){
      sc.stick.style.height = hs+'px';
      sc.stage.style.setProperty('--st','0px');
      sc.stage.style.transform = 'scale('+sc.s+')';
      sc.el.style.height = hs+'px';
      sc.el.style.marginTop = '0px';
      return;
    }
    /* centred in the frame, and it stays put. Re-centring against the live viewport was tried
       (Sep 21): iPhone Safari toggles its bar on every change of scroll direction and the board
       swam 30px under the thumb. */
    sc.stage.style.setProperty('--st', ((vh-hs)/2)+'px');
    sc.stick.style.height = (mobile && !reduced) ? vh+'px' : '';
    var last = (i === scenes.length-1);
    var live=sc.live + ((mobile && sc.el.id==='b9') ? .7 : 0);   /* phones: the closer holds longer before the footer */
    sc.el.style.height = (vh + live*vh + (last ? (FADEF+.15)*vh : (READF + 2*FADEF)*vh))+'px';
    sc.el.style.marginTop = (-(FADEF+1)*vh)+'px';
    sc.stage.style.transform = 'scale('+sc.s+')';
  });
  if(window.__sizeSitefoot) window.__sizeSitefoot();
}
(function(){
  var sfd=document.getElementById('sfd'), sf=document.getElementById('sitefoot');
  window.__sizeSitefoot=function(){
    if(!sfd||!sf) return;
    if(document.body.classList.contains('m')){ sf.style.height='auto'; return; }
    var vw=document.documentElement.clientWidth, ss=vw/1600;
    sfd.style.transform='scale('+ss+')';
    sf.style.height=(620*ss)+'px';
  };
})();
layout();
window.addEventListener('resize', onResize);

/* ---------- loader: OAKMAN condenses out of the fog, gated on the hero film ---------- */
var loader = document.getElementById('loader');
if(reduced){ if(loader) loader.style.display='none'; }
else (function(){
  var lmark=document.getElementById('lmark'), lchars=[];
  var t0=null, REV_START=250, REV_TRAVEL=850, REV_WIN=260,
      MIN_HOLD=2050, MAX_WAIT=4500, dropped=false;
  (function(){
    var text=lmark.textContent; lmark.textContent='';
    for(var i=0;i<text.length;i++){
      var sp=document.createElement('span'); sp.className='c'; sp.textContent=text[i];
      lmark.appendChild(sp); lchars.push(sp);
    }
  })();
  function heroReady(){
    var m=document.querySelector('.hstage video');
    if(!m) return Promise.resolve();
    if(m.readyState>=3) return Promise.resolve();
    return new Promise(function(res){
      m.addEventListener('canplay',res,{once:true});
      m.addEventListener('error',res,{once:true});
    });
  }
  function fog(now){
    if(t0===null) t0=now;
    var t=now-t0, n=lchars.length, done=true;
    for(var i=0;i<n;i++){
      var u=Math.min(1,Math.max(0,(t-(REV_START+i*(REV_TRAVEL/n)))/REV_WIN));
      var st=lchars[i].style;
      st.opacity=u;
      st.filter=u>=1?'none':'blur('+((1-u)*5)+'px)';
      if(u<1) done=false;
    }
    if(t>=REV_START+REV_TRAVEL*.55) loader.classList.add('tagin');
    if(!done||t<MIN_HOLD) requestAnimationFrame(fog);
  }
  requestAnimationFrame(fog);
  function drop(){
    if(dropped) return; dropped=true;
    loader.classList.add('done');
    loader.addEventListener('transitionend',function(){ loader.style.display='none'; },{once:true});
    if(window.__railLand) window.__railLand();
  }
  var minHold=new Promise(function(res){ setTimeout(res,MIN_HOLD); });
  Promise.all([minHold, Promise.race([heroReady(), new Promise(function(res){ setTimeout(res,MAX_WAIT); })])]).then(drop);
})();

function clamp01(v){ return Math.min(1,Math.max(0,v)); }

/* ---------- reveals ---------- */
/* only the active board's reveals count: the other breakpoint's board is hidden
   but still intersects, and must neither reveal nor pad the stagger */
function onActiveBoard(el){
  var st=el.closest('.stage'); if(!st) return true;
  return mobile ? st.classList.contains('m') : st.classList.contains('d');
}
var io = new IntersectionObserver(function(es){
  var i=0;
  es.forEach(function(e){ if(e.isIntersecting && onActiveBoard(e.target)){ (function(k){ setTimeout(function(){ e.target.classList.add('in'); }, k*110); })(i++); io.unobserve(e.target); }});
},{threshold:.3});
document.querySelectorAll('.rv,.rvf').forEach(function(el){ io.observe(el); });

/* ---------- flow engine: the lines draw WITH the scroll, imagery holds depth ----------
   This is the Seasats grammar: nothing pops, everything rides the reader's hand. */
var plxEls = Array.prototype.slice.call(document.querySelectorAll('[data-plx]')).map(function(el){
  return {el:el, depth:parseFloat(el.getAttribute('data-plx'))||0, cur:0};
});
var drawSvgs = [];
/* paths inside a display:none board (the other breakpoint's art) measure 0;
   they are measured lazily the first time their svg is actually on screen */
function measureDraw(d){
  d.items = d.paths.map(function(p){
    var L = p.getTotalLength ? p.getTotalLength() : 0;
    if(L){ p.style.strokeDasharray = L; p.style.strokeDashoffset = L; p.style.transition = 'none'; }
    return {p:p, L:L, cur:null};
  }).filter(function(it){ return it.L; });
  d.ready = d.items.length>0;
}
document.querySelectorAll('svg').forEach(function(svg){
  var paths = Array.prototype.slice.call(svg.querySelectorAll('.draw'));
  if(!paths.length) return;
  var d={svg:svg, scene:svg.closest('.scene'), paths:paths, items:[], ready:false};
  measureDraw(d);
  drawSvgs.push(d);
});
function centerP(el){
  var r = el.getBoundingClientRect();
  return ((VH/2) - (r.top + r.height/2)) / ((VH + r.height)/2);
}
function flowTick(){
  var vh = VH, k = reduced ? 1 : (mobile ? .2 : .09);   /* phones: parallax follows the thumb, less trailing */
  plxEls.forEach(function(o){
    var host = o.el.closest('section') || o.el;
    var t = Math.max(-1, Math.min(1, centerP(host))) * o.depth * 140;
    o.cur += (t - o.cur) * k;
    o.el.style.setProperty('--plx', o.cur.toFixed(2) + 'px');
  });
  drawSvgs.forEach(function(d){
    if(!d.ready){ if(d.svg.getBoundingClientRect().width>0) measureDraw(d); if(!d.ready) return; }
    /* the lines extend from their anchor dots AS the scene dissolves in */
    var p;
    if(d.scene){
      var sr = d.scene.getBoundingClientRect();
      if(sr.bottom < -80 || sr.top > vh + 80) return;
      var q = (sr.top >= 0) ? 0 : Math.max(0, Math.min(1, -sr.top/(FADEF*vh)));
      p = Math.max(0, Math.min(1, q*1.25 - .1));
    } else {
      var r = d.svg.getBoundingClientRect();
      if(r.bottom < -80 || r.top > vh + 80) return;
      p = Math.max(0, Math.min(1, (vh - r.top) / (vh * .85)));
    }
    var step = Math.min(.04, .4 / d.items.length);
    d.items.forEach(function(it, i){
      var lp = Math.max(0, Math.min(1, p * 1.4 - i * step));
      var t = it.L * (1 - lp);
      if(it.cur === null) it.cur = t;
      it.cur += (t - it.cur) * (reduced ? 1 : .12);
      it.p.style.strokeDashoffset = it.cur;
    });
  });
}

/* smoothed wheel: the page glides instead of stepping (mouse/trackpad only) */
var glide = null;
if(!reduced && !window.matchMedia('(pointer: coarse)').matches){
  (function(){
    var target = window.scrollY, current = target, gliding = false;
    function maxY(){ return document.documentElement.scrollHeight - window.innerHeight; }
    window.addEventListener('wheel', function(e){
      if(e.ctrlKey) return;
      e.preventDefault();
      var d = e.deltaY * (e.deltaMode === 1 ? 16 : 1);
      target = Math.max(0, Math.min(maxY(), target + d));
      gliding = true;
    }, {passive:false});
    window.addEventListener('scroll', function(){ if(!gliding){ target = current = window.scrollY; } }, {passive:true});
    glide = function(){
      if(!gliding) return;
      current += (target - current) * .1;
      if(Math.abs(target - current) < .4){ current = target; gliding = false; }
      window.scrollTo(0, current);
    };
    glide.to = function(y){ target = Math.max(0, Math.min(maxY(), y)); gliding = true; };
  })();
}

/* ---------- hero: film gives way to the dark on the first flicks of the wheel ---------- */
var heroSeq=document.getElementById('heroSeq'),
    shade=document.getElementById('heroshade'),
    heroword=document.getElementById('heroword'),
    herotag=document.getElementById('herotag'),
    herohint=document.getElementById('herohint'),
    herovid=document.querySelector('.hstage video');
/* data saver: keep the poster, do not pull 3.4MB of film on a metered phone */
if(herovid && navigator.connection && navigator.connection.saveData){
  herovid.removeAttribute('autoplay'); herovid.preload='none'; herovid.src='';
}
function pinProgress(el){
  var r=el.getBoundingClientRect(), total=r.height-VH;
  return total>0 ? clamp01(-r.top/total) : 1;
}
var b4pulls=Array.prototype.slice.call(document.querySelectorAll('[data-pull]')).map(function(el){
  return {el:el, stag:parseFloat(el.getAttribute('data-pull'))||0};
});
if(!reduced) b4pulls.forEach(function(o){ o.el.style.opacity=0; o.el.style.transform='translateY(90px)'; });
function updateHero(){
  if(reduced) return;
  var vh=VH;
  /* the film's own beat: wordmark and tagline breathe out over the first half-viewport */
  var hp=clamp01(window.scrollY/(vh*.55));
  var t=1-hp;
  heroword.style.opacity=t; herotag.style.opacity=t; herohint.style.opacity=t;
  /* the film recedes as 04 dissolves in over it */
  var q = scenes.length ? sceneQ(scenes[0]) : 0;
  shade.style.opacity=q*.55;
  if(herovid){
    herovid.style.transform='scale('+(1-q*.05)+')';
    if(q>=1 && !herovid.paused) herovid.pause();
    else if(q<1 && herovid.paused && herovid.readyState>=2) herovid.play().catch(function(){});
  }
  b4pulls.forEach(function(o){
    var u=clamp01(q*1.8-o.stag*1.8);
    var e=1-Math.pow(1-u,3);
    o.el.style.opacity=e;
    o.el.style.transform='translateY('+((1-e)*90).toFixed(1)+'px)';
  });
}
function sceneQ(sc){
  var r=sc.el.getBoundingClientRect();
  if(r.top>=0) return 0;
  return clamp01(-r.top/(FADEF*VH));
}
function sceneTick(){
  if(reduced) return;
  var vh=VH;
  scenes.forEach(function(sc){
    var r=sc.el.getBoundingClientRect();
    if(r.top>vh+60){ sc.stick.style.opacity=0; sc.stick.classList.remove('live'); return; }  /* still below: invisible */
    if(r.bottom<-60){ sc.stick.style.opacity=1; sc.stick.classList.remove('live'); return; } /* long past: opaque beneath */
    var q=sceneQ(sc);
    sc.stick.style.opacity=(r.top>0)?0:q;
    /* an invisible or half-faded scene must never intercept the one beneath it */
    var live=(r.top<=0 && q>=.6);
    /* 08 (phone): the JP/EN swap starts only once the slide is fully in view */
    if(mobile && sc.el.id==='b8' && q>=1 && !sc.jpRun){ sc.jpRun=true;
      sc.stage.querySelectorAll('.jpsw').forEach(function(el){ el.classList.add('run'); }); }
    if(live && !sc.stick.classList.contains('live')){
      /* belt and braces for the reveals: the observer normally does this, but a
         scene that is live must never sit with hidden imagery */
      var board=sc.stage;
      setTimeout(function(){ board.querySelectorAll('.rv:not(.in),.rvf:not(.in)').forEach(function(el){ el.classList.add('in'); }); },80);

    }
    sc.stick.classList.toggle('live', live);
    /* the arriving page settles from a hair large, like a load-in */
    sc.stick.style.transform=(q<1)?('scale('+(1+(1-q)*.012)+')'):'none';
  });
}

/* ---------- 03: the line assembles word by word with the scroll, then holds ---------- */
var b3sc=null;
scenes.forEach(function(sc){ if(sc.el.id==='b3pin') b3sc=sc; });
var turnwords=Array.prototype.slice.call(document.querySelectorAll('.turnline .w'));
turnwords.forEach(function(w){ w.style.display='inline-block'; w.style.opacity=0; w.style.willChange='opacity,filter'; });
var turnGroups=[];
turnwords.forEach(function(w){ var st=w.closest('.stage'); var g=null; turnGroups.forEach(function(x){ if(x.stage===st) g=x; }); if(!g){ g=[]; g.stage=st; turnGroups.push(g); } g.push(w); });
function updateTurn(){
  if(!b3sc) return;
  var vh=VH, r=b3sc.el.getBoundingClientRect();
  /* the scene fades in from the cream first; the words assemble in its live beat */
  var p=clamp01((-r.top - FADEF*vh) / (b3sc.live*vh));
  /* each board's line assembles over its own word count (desktop and portrait boards both carry one) */
  turnGroups.forEach(function(g){
    var n=g.length;
    for(var i=0;i<n;i++){
      var t=reduced?1:clamp01((p-(.06+i*(.6/n)))/.12);
      var st=g[i].style;
      st.opacity=t;
      st.filter=t>=1?'none':'blur('+((1-t)*8)+'px)';
    }
  });
}
if(reduced) turnwords.forEach(function(w){ w.style.opacity=1; });

/* ---------- 06: Movement / Work / Training are click-driven; the page scrolls past ---------- */
var b6=document.getElementById('b6'), dayNow=-1;
var tabs=Array.prototype.slice.call(document.querySelectorAll('.tabbtn'));
var panes=Array.prototype.slice.call(document.querySelectorAll('.daypane'));
var vids=[document.getElementById('dv0'),document.getElementById('dv1'),document.getElementById('dv2')];
var mvids=[document.getElementById('mdv0'),document.getElementById('mdv1'),document.getElementById('mdv2')].filter(Boolean);
function setDay(k){
  if(k===dayNow) return;
  dayNow=k;
  tabs.forEach(function(t){ t.classList.toggle('on', +t.getAttribute('data-day')===k); });
  panes.forEach(function(pn){ pn.classList.toggle('on', +pn.getAttribute('data-pane')===k); });
  vids.forEach(function(v,i){
    v.parentNode.classList.toggle('on', i===k);
    if(i===k && !mobile){ if(v.readyState<2) v.load(); v.play().catch(function(){}); }
    else v.pause();
  });
  mvids.forEach(function(v,i){
    v.parentNode.classList.toggle('on', i===k);
    if(i===k && mobile){ if(v.readyState<2) v.load(); v.play().catch(function(){}); }
    else v.pause();
  });
}
tabs.forEach(function(t){
  t.addEventListener('click',function(){ setDay(+t.getAttribute('data-day')); });
});
setDay(0);
/* pause the day clips entirely while the section is off screen */
var vio=new IntersectionObserver(function(es){
  es.forEach(function(e){
    if(e.isIntersecting){ var v=(mobile?mvids:vids)[dayNow]; if(v){ v.play().catch(function(){}); } }
    else { vids.forEach(function(v){ v.pause(); }); mvids.forEach(function(v){ v.pause(); }); }
  });
},{threshold:.05});
vio.observe(b6);

/* ---------- 05 accordions: one open per section (two variants on the page) ---------- */
document.querySelectorAll('.accwrap').forEach(function(wrap){
  var rows=Array.prototype.slice.call(wrap.querySelectorAll('.acc-row'));
  rows.forEach(function(row,i){
    row.querySelector('.acc-btn').addEventListener('click',function(){
      rows.forEach(function(r,j){
        if(j===i && r.classList.contains('open')){ r.classList.remove('open'); r.querySelector('.acc-mark').innerHTML='+'; return; }
        r.classList.toggle('open', j===i);
        r.querySelector('.acc-mark').innerHTML = (j===i)?'&ndash;':'+';
      });
      b5Arrows(); b5GlowD();
    });
  });
});
/* 05 (desktop): the open row's callout line and dot glow, same as the phone */
function b5GlowD(){
  var st=document.querySelector('#b5A .stage.d'); if(!st) return;
  var rows=st.querySelectorAll('.acc-row'), leads=st.querySelectorAll('path.dlead'), dots=st.querySelectorAll('circle.ddot');
  rows.forEach(function(row,i){
    var on=row.classList.contains('open');
    if(leads[i]) leads[i].classList.toggle('lit',on);
    if(dots[i]) dots[i].classList.toggle('lit',on);
  });
}
setTimeout(b5GlowD,50);
/* 05 (mobile): the callout arrows follow the +/- marks, which move as rows open */
function b5Arrows(){
  var st=document.querySelector('#b5A .stage.m'); if(!st || !mobile) return;
  var r=st.getBoundingClientRect(), sc=r.width/390; if(!sc) return;
  var marks=st.querySelectorAll('.acc-mark'), branches=st.querySelectorAll('path.accbranch'), trunk=st.querySelector('path.acctrunk');
  var changed=false, last=464, ys=[];
  /* offsets, not client rects: the rows carry a translateY before they reveal */
  var wrap=st.querySelector('.accwrap');
  marks.forEach(function(m,i){
    var row=m.closest('.acc-row');
    var ml=wrap.offsetLeft+row.offsetLeft+m.offsetLeft, my=wrap.offsetTop+row.offsetTop+m.offsetTop+m.offsetHeight/2; ys.push(my); last=my;
    var b=branches[i]; if(!b) return;
    var d='M14 '+my.toFixed(1)+' H'+(ml-3).toFixed(1);
    if(b.getAttribute('d')!==d){ b.setAttribute('d',d); changed=true; }
  });
  /* the open row's lead, dot and branch glow; the trunk glows with any row open */
  var rows=st.querySelectorAll('.acc-row'), leads=st.querySelectorAll('path.acclead'), dots=st.querySelectorAll('circle.accdot'), any=false;
  rows.forEach(function(row,i){
    var on=row.classList.contains('open'); any=any||on;
    if(leads[i]) leads[i].classList.toggle('lit',on);
    if(dots[i]) dots[i].classList.toggle('lit',on);
    if(branches[i]) branches[i].classList.toggle('lit',on);
  });
  if(trunk) trunk.classList.toggle('lit',any);
  var td='M14 464 V'+last.toFixed(1);
  if(trunk && trunk.getAttribute('d')!==td){ trunk.setAttribute('d',td); changed=true; }
  if(changed) drawSvgs.forEach(function(dd){ if(st.contains(dd.svg)) dd.items.forEach(function(it){ if(it.p.classList.contains('accbranch')||it.p.classList.contains('acctrunk')){ it.L=it.p.getTotalLength(); it.p.style.strokeDasharray=it.L; it.cur=null; } }); });
}
window.addEventListener('resize',function(){ if(document.documentElement.clientWidth<MOBILE_BP && document.documentElement.clientWidth===lastVW) return; setTimeout(b5Arrows,60); });
setTimeout(b5Arrows,50);

/* ---------- "Shop the cryo system" ----------
   There is no product to link to yet, and href="#" jumped the reader to the top
   of the page, which is worse than a dead button.

   Order of preference:
     1. an explicit Klaviyo form id (section setting) -> open that popup
     2. the launch drawer -> Mandy's panel, anchored to the viewport
     3. nothing available -> scroll to the Founding 100 form

   The drawer is deliberately NOT modal: no scrim, no scroll lock. The film's
   grammar is "nothing pops, everything rides the reader's hand", and the
   Klaviyo popup freezing the body is the exact failure being avoided here. */
(function(){
  var drawer = document.getElementById('oakcryo');
  var join   = document.getElementById('oakcryojoin');
  var closeB = document.getElementById('oakcryox');
  var opener = null;

  function openDrawer(from){
    opener = from || null;
    drawer.hidden = false;
    /* next frame, so the transition runs from the hidden position */
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        drawer.classList.add('on');
        var i = drawer.querySelector('input[type=email]');
        if(i) try{ i.focus({preventScroll:true}); }catch(e){ i.focus(); }
      });
    });
  }
  function closeDrawer(){
    drawer.classList.remove('on');
    var done = function(){ drawer.hidden = true; drawer.removeEventListener('transitionend', done); };
    if(reduced){ done(); } else { drawer.addEventListener('transitionend', done); setTimeout(done, 700); }
    if(opener) try{ opener.focus({preventScroll:true}); }catch(e){}
    opener = null;
  }

  if(drawer && closeB){
    closeB.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && !drawer.hidden) closeDrawer();
    });

    var form = drawer.querySelector('.oakcryo-form');
    var btn  = form ? form.querySelector('button[type=submit]') : null;
    if(form) form.addEventListener('submit', function(e){
      e.preventDefault();
      var input = form.querySelector('input[type=email]');
      var email = input ? String(input.value||'').trim() : '';
      if(!email) return;
      join.classList.remove('err');
      if(btn) btn.disabled = true;
      var go = (typeof window.oakSubscribe === 'function')
        ? window.oakSubscribe(email, 'Cryo system CTA')
        : Promise.reject(new Error('oakSubscribe missing'));
      go.then(function(){
        join.classList.add('sub');
      }).catch(function(err){
        if(btn) btn.disabled = false;
        join.classList.add('err');
        if(window.console && console.error) console.error('[OAK] signup failed:', err);
      });
    });
  }

  document.querySelectorAll('.oak-cryo-cta').forEach(function(a){
    a.addEventListener('click', function(e){
      var cfg = window.OAK_KLAVIYO || {};
      var kl  = window._klOnsite;
      if(cfg.ctaFormId && kl && typeof kl.openForm === 'function'){
        e.preventDefault();
        kl.openForm([cfg.ctaFormId]);
        return;
      }
      if(drawer){
        e.preventDefault();
        openDrawer(a);
        return;
      }
      var target = null;
      document.querySelectorAll('.sitefoot .fjoin').forEach(function(el){
        if(!target && el.offsetParent !== null) target = el;
      });
      if(!target) return;
      e.preventDefault();
      target.scrollIntoView({block:'center'});
      var i2 = target.querySelector('input[type=email]');
      if(i2) setTimeout(function(){ try{ i2.focus({preventScroll:true}); }catch(err){ i2.focus(); } }, 60);
    });
  });
})();

/* ---------- site footer: the Founding 100 form subscribes to Klaviyo ----------
   Posts through window.oakSubscribe (assets/oak-klaviyo.js, configured by
   snippets/oak-klaviyo.liquid). Adding the profile to list UAYYvE triggers the
   live "Welcome (Sauna Playbook)" flow, so nothing here sends the email itself. */
document.querySelectorAll('.sitefoot .fsub').forEach(function(f){
  var join = f.closest('.fjoin');
  var btn  = f.querySelector('button[type=submit]');
  var errEl = null;
  function showErr(msg){
    if(!errEl){
      errEl = document.createElement('p');
      errEl.style.cssText = 'margin:8px 0 0;font-family:var(--body);font-weight:400;font-size:13.5px;line-height:1.5;color:#C4552A';
      f.parentNode.insertBefore(errEl, f.nextSibling);
    }
    errEl.textContent = msg;
  }
  f.addEventListener('submit',function(e){
    e.preventDefault();
    if(!join) return;
    var input = f.querySelector('input[type=email]');
    var email = input ? String(input.value||'').trim() : '';
    if(!email) return;
    if(errEl) errEl.textContent = '';
    if(btn) btn.disabled = true;
    var go = (typeof window.oakSubscribe === 'function')
      ? window.oakSubscribe(email)
      : Promise.reject(new Error('oakSubscribe missing'));
    go.then(function(){
      join.classList.add('sub');
    }).catch(function(err){
      if(btn) btn.disabled = false;
      showErr('That didn\u2019t go through. Try again in a moment.');
      if(window.console && console.error) console.error('[OAK] signup failed:', err);
    });
  });
});

/* ---------- 08B (mobile): the cotton table as tabs + one card ---------- */
document.querySelectorAll('.ctab').forEach(function(t){
  t.addEventListener('click',function(){
    var k=t.getAttribute('data-ct');
    document.querySelectorAll('.ctab').forEach(function(x){ x.classList.toggle('on',x.getAttribute('data-ct')===k); });
    document.querySelectorAll('.ccard').forEach(function(x){ x.classList.toggle('on',x.getAttribute('data-ct')===k); });
  });
});

/* ---------- 07 fabric keys ---------- */
function setKey(k){
  document.querySelectorAll('.fcard').forEach(function(c){ c.classList.toggle('on', c.getAttribute('data-card')===k); });
  document.querySelectorAll('.ftab').forEach(function(t){ t.classList.toggle('on', t.getAttribute('data-key')===k); });
}
/* the copy keys on the left still respond to hover; inside the box, only clicks
   on the bottom tabs switch the card (Adam, review round 1) */
document.querySelectorAll('.fkey').forEach(function(el){
  el.addEventListener('mouseenter',function(){ setKey(el.getAttribute('data-key')); });
  el.addEventListener('click',function(){ setKey(el.getAttribute('data-key')); });
});
document.querySelectorAll('.ftab').forEach(function(el){
  el.addEventListener('click',function(){ setKey(el.getAttribute('data-key')); });
});


/* ---------- the rail: where you are, and how far through each block ---------- */
var railRows = Array.prototype.slice.call(document.querySelectorAll('#rail button'));
var railThumb = document.getElementById('railthumb'),
    railImg = document.getElementById('railimg'),
    railWord = document.getElementById('railword'),
    railFill = document.getElementById('railfill');
var THUMBS = window.OAK.thumbs;
var WORDS = {};
function railTarget(id){
  var vh=VH;
  if(id==='hero') return 0;
  for(var i=0;i<scenes.length;i++) if(scenes[i].el.id===id){
    var r=scenes[i].el.getBoundingClientRect();
    return window.scrollY + r.top + FADEF*vh;
  }
  return 0;
}
railRows.forEach(function(b){
  b.addEventListener('click',function(){
    var y=railTarget(b.getAttribute('data-go'));
    if(glide && glide.to) glide.to(y);
    else window.scrollTo({top:y,behavior:'smooth'});
  });
});

/* the rail rests as a colored strip; hovering it slides the full menu out */
var railEl=document.getElementById('rail'), railMark=document.getElementById('railmark'),
    railHot=document.getElementById('railhot');
var thumbTimer=null, thumbOn=false;
function showThumb(on){ thumbOn=on; railThumb.style.opacity=on?'1':'0'; }
function railOut(open){
  railEl.classList.toggle('out',open);
  railThumb.classList.toggle('beside',open);
  railMark.classList.toggle('hidden',open);
  if(open){ if(thumbTimer){ clearTimeout(thumbTimer); thumbTimer=null; } showThumb(true); }
}
railEl.addEventListener('mouseenter',function(){ railOut(true); });
railEl.addEventListener('mouseleave',function(){ railOut(false); });
railHot.addEventListener('mouseenter',function(){ railOut(true); });
railHot.addEventListener('mouseleave',function(e){
  if(!(e.relatedTarget && railEl.contains(e.relatedTarget))) railOut(false);
});
/* seasats landing: as the loader lifts, the menu greets you open, holds a
   beat (1.5s), then tucks away. scrolling during the hold does not cut it short. */
window.__railLand=function(){
  if(window.innerWidth<1100) return;
  railOut(true); showThumb(false);
  /* .9s loader fade + a full 1.5s in view */
  setTimeout(function(){
    if(!(railEl.matches(':hover')||railHot.matches(':hover'))) railOut(false);
  },2400);
};
/* the thumbnail keeps to itself: it appears when the cursor visits the right
   fifth of the screen and slips away three seconds after it leaves */
document.addEventListener('mousemove',function(e){
  if(window.innerWidth<1100) return;
  if(e.clientX > window.innerWidth*.8){
    if(thumbTimer){ clearTimeout(thumbTimer); thumbTimer=null; }
    if(!thumbOn) showThumb(true);
  } else if(thumbOn && !thumbTimer){
    thumbTimer=setTimeout(function(){ showThumb(false); thumbTimer=null; },3000);
  }
});
/* ---------- MOBILE wayfinding: built from the same rail rows ---------- */
var medge=document.getElementById('medge'), mmenu=document.getElementById('mmenu'),
    msheet=document.getElementById('msheet'), mscrim=document.getElementById('mscrim'),
    msrows=document.getElementById('msrows'), msegs=[], mrows=[];
if(medge && msrows){
  railRows.forEach(function(b){
    var id=b.getAttribute('data-go');
    var seg=document.createElement('i'); seg.style.setProperty('--seg', b.style.backgroundColor||'#EBE3D7');
    medge.appendChild(seg); msegs.push({el:seg,id:id});
    var row=document.createElement('button'); row.type='button'; row.className='srow'; row.setAttribute('data-go',id);
    var n=b.querySelector('.rn'), l=b.querySelector('.rl');
    row.innerHTML='<span class="sn">'+(n?n.textContent:'')+'</span><img src="'+(THUMBS[id]||window.OAK.thumbs.hero)+'" alt="" loading="lazy"><span class="sl">'+(l?l.textContent:'')+'</span>';
    row.addEventListener('click',function(){
      sheet(false);
      var y=railTarget(id);
      setTimeout(function(){ window.scrollTo({top:y,behavior:'smooth'}); },120);
    });
    msrows.appendChild(row); mrows.push(row);
  });
  function sheet(open){
    document.body.classList.toggle('sheet',open);
    mmenu.setAttribute('aria-expanded',open?'true':'false');
    msheet.setAttribute('aria-hidden',open?'false':'true');
  }
  mmenu.addEventListener('click',function(){ sheet(!document.body.classList.contains('sheet')); });
  document.getElementById('msclose').addEventListener('click',function(){ sheet(false); });
  mscrim.addEventListener('click',function(){ sheet(false); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') sheet(false); });
}
var medgemark=document.getElementById('medgemark');
function medgeTick(act,prog){
  if(!msegs.length) return;
  msegs.forEach(function(s){ var on=s.id===act; s.el.classList.toggle('on',on);
    if(on && medgemark){ var r=s.el.getBoundingClientRect(); medgemark.style.top=(r.top + prog*r.height - 6)+'px'; } });
  mrows.forEach(function(r){ r.classList.toggle('on', r.getAttribute('data-go')===act); });
}
var railNow='';
function railTick(){
  if(!railRows.length) return;
  var vh=VH;
  /* active scene: the last one at least half dissolved in */
  var act='hero', prog=0;
  var heroH=heroSeqEl.offsetHeight;
  prog=clamp01(window.scrollY/Math.max(1,heroH-vh));
  scenes.forEach(function(sc){
    if(sceneQ(sc)>=.5){
      act=sc.el.id;
      var r=sc.el.getBoundingClientRect();
      prog=clamp01(-r.top/Math.max(1,(sc.el.offsetHeight-vh)));
    }
  });
  if(window.innerWidth<1100){ medgeTick(act,prog); return; }
  var row=null;
  railRows.forEach(function(b){ var on=b.getAttribute('data-go')===act; b.classList.toggle('on',on); if(on) row=b; });
  if(!row) return;
  if(act!==railNow){
    railNow=act;
    var t=THUMBS[act]||'';
    if(t){ railThumb.classList.remove('textmode'); railImg.src=t; }
    else { railThumb.classList.add('textmode'); railWord.textContent=WORDS[act]||''; }
  }
  var rr=row.getBoundingClientRect();
  if(railMark) railMark.style.top=(rr.top + rr.height/2 - 7)+'px';
  var th=railThumb.offsetHeight||80;
  var top=rr.top + prog*rr.height - th/2;
  top=Math.max(8, Math.min(window.innerHeight-th-8, top));
  railThumb.style.top=top+'px';
  railFill.style.width=(prog*100).toFixed(1)+'%';
}

/* ---------- scroll telemetry: the page as odometer ----------
   Real measurement, not theater. Distance = every CSS pixel the reader actually
   scrolled (up and down both count), converted at 96px/inch. Speed = that
   distance over only the time spent actively scrolling (gaps >250ms between
   scroll events don't count, so reading pauses don't dilute the knots). */
(function(){
  var um=document.getElementById('odoUm'); if(!um) return;
  var kn=document.getElementById('odoKn'), xEl=document.getElementById('odoX'), tEl=document.getElementById('odoT');
  var PX_M=0.0254/96;          /* meters per CSS pixel */
  var SPERM=50e-6;             /* sperm cruise, m/s */
  var KNOT=0.514444;           /* m/s per knot */
  var dist=0, active=0, lastY=window.scrollY, lastT=0, dirty=false;
  window.addEventListener('scroll',function(){
    var now=performance.now();
    dist+=Math.abs(window.scrollY-lastY)*PX_M; lastY=window.scrollY;
    if(lastT){ var dt=(now-lastT)/1000; if(dt<.25) active+=dt; }
    lastT=now; dirty=true;
  },{passive:true});
  function fmtUm(m){
    var v=m*1e6;
    return v>=1e6 ? (v/1e6).toFixed(1)+' million' : Math.round(v).toLocaleString('en-US');
  }
  function fmtT(s){
    if(s<60) return Math.max(1,Math.round(s))+' seconds';
    if(s<3600) return Math.round(s/60)+' minutes';
    var h=s/3600;
    return (h<10 ? h.toFixed(1) : Math.round(h))+' hours';
  }
  setInterval(function(){
    if(!dirty) return; dirty=false;
    var spd = active>.3 ? dist/active : 0;
    um.textContent=fmtUm(dist);
    kn.textContent=(spd/KNOT).toFixed(3);
    xEl.textContent=spd>0 ? Math.round(spd/SPERM).toLocaleString('en-US') : '—';
    tEl.textContent=dist>0 ? fmtT(dist/SPERM) : '—';
  },400);
})();
/* the thumbnail keeps to itself: it appears when the cursor visits the right
   fifth of the screen and slips away three seconds after it leaves */
document.addEventListener('mousemove',function(e){
  if(window.innerWidth<1100) return;
  if(e.clientX > window.innerWidth*.8){
    if(thumbTimer){ clearTimeout(thumbTimer); thumbTimer=null; }
    if(!thumbOn) showThumb(true);
  } else if(thumbOn && !thumbTimer){
    thumbTimer=setTimeout(function(){ showThumb(false); thumbTimer=null; },3000);
  }
});

/* ---------- ?fps=1: a corner readout of real frame rate on the device, so "feels slow"
   can be split into "the page is dropping frames" vs "the deck asks for too much thumb" ---------- */
var fpsEl=null, fpsN=0, fpsT=0, fpsMin=99;
if(/[?&]fps=1/.test(location.search)){
  fpsEl=document.createElement('div');
  fpsEl.style.cssText='position:fixed;left:8px;bottom:calc(8px + env(safe-area-inset-bottom));z-index:99;font:700 13px/1.2 -apple-system,system-ui,sans-serif;color:#fff;background:rgba(16,24,32,.85);padding:6px 9px;border-radius:6px;pointer-events:none;white-space:pre';
  document.body.appendChild(fpsEl);
}
/* ---------- the one loop: glide, pins, depth, drawing ---------- */
(function loop(t){
  if(glide) glide();
  sceneTick(); updateHero(); updateTurn(); flowTick(); railTick();
  if(fpsEl){
    fpsN++;
    if(t-fpsT>=500){
      var f=Math.round(fpsN*1000/(t-fpsT)); if(f<fpsMin && f>0) fpsMin=f;
      fpsEl.textContent=f+' fps  (low '+fpsMin+')\nscroll '+Math.round(window.scrollY)+'  fade '+FADEF+' read '+READF+'\nVH '+Math.round(VH)+'  inner '+window.innerHeight+'  svh '+readVH()+'  lvh '+readLVH()+'  screen '+screen.height;
      fpsN=0; fpsT=t;
    }
  }
  requestAnimationFrame(loop);
})(performance.now());
layout();
window.addEventListener('resize', onResize);
})();
